import { router } from '@inertiajs/react'
import { NewStreamWizard } from '@/components/streams'
import type {
  WizardStep,
  SampleQuestion,
  SampleGemCriterion,
  WizardState,
  GemCriteriaTemplate,
} from '@/types/streams'

interface StreamsNewPageProps {
  wizardSteps: WizardStep[]
  sampleQuestions: SampleQuestion[]
  sampleGemCriteria: SampleGemCriterion[]
  gemCriteriaTemplates?: GemCriteriaTemplate[]
}

export default function StreamsNewPage({
  wizardSteps,
  sampleQuestions,
  sampleGemCriteria,
  gemCriteriaTemplates = [],
}: StreamsNewPageProps) {
  const handleComplete = (data: WizardState) => {
    router.post('/streams', {
      stream: {
        name: data.name,
        description: data.description,
        sources_attributes: data.sources.map((s) => ({
          source_type: s.type,
          label: s.label,
        })),
        questions_attributes: data.questions.map((q, index) => ({
          text: q.text,
          description: q.description,
          response_format: q.responseFormat,
          position: index + 1,
        })),
        gem_criteria_attributes: data.gemCriteria.map((gc) => ({
          title: gc.title,
          description: gc.description,
          notify_immediately: gc.notifyImmediately,
        })),
      },
    })
  }

  const handleCancel = () => {
    router.visit('/streams')
  }

  return (
    <NewStreamWizard
      wizardSteps={wizardSteps}
      sampleQuestions={sampleQuestions}
      sampleGemCriteria={sampleGemCriteria}
      gemCriteriaTemplates={gemCriteriaTemplates}
      onComplete={handleComplete}
      onCancel={handleCancel}
    />
  )
}
